import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { flatten } from 'flattenjs';
@Injectable({
  providedIn: 'root',
})
export class FormSubmitterService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  submitForm(params: object, targetUrl: string) {
    const form = this.renderer.createElement('form');
    form.method = 'post';
    form.action = targetUrl;
    this.getFormFields(params).forEach(([name, value]) => {
      const hiddenField = this.renderer.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = name;
      hiddenField.value = value;
      form.appendChild(hiddenField);
    });
    this.renderer.selectRootElement('body').appendChild(form);
    form.submit();
  }

  getFormFields(params: object): [string, string][] {
    return Object.entries(flatten(params))
      .filter(([_, value]) => value !== undefined && value !== null)
      .map(([key, value]) => [key, value.toString()]);
  }
}
